import {get_devices, getNode_status, get_all_v, get_pages_config, get_three_config, get_geo_params} from '../api';
import {logout} from '../utils/plugin';

const mutations = {
    update(state) {
        console.log('update')
        state.role = localStorage.getItem('role')
        state.username = localStorage.getItem('username')

        // 获取节点状态
        getNode_status().then(res => {
            setTimeout(() => {
                state.nodes = res.node_status.sort((a, b) => {
                    if (a.status === b.status) {
                        if (a.status === 'green') return 0
                    } else if (a.status === 'gray') return 1
                    else return -1
                });
                state.online_names = res.node_status.filter(x => x.status === 'green').map(x => x.value)
                state.offline_names = res.node_status.filter(x => x.status !== 'green').map(x => x.value)
                state.nodes_display = res.display
            }, 0)
        })

        // 设备信息
        get_devices().then(res => {
            setTimeout(() => {
                const info = res.devices_info
                state.devices_info = info
                state.devices_pool = info.map(ele => ({ 'id': ele.id }))
                state.devices_availble = info.filter(ele => !ele.bind).map(ele => ({ 'id': ele.id }))
                state.devices_stored = info.filter(ele => ele.bind).map(ele => ({ 'id': ele.id }))
                state.pointData = info.map(ele => ({ 'name': ele.name, 'value': 140, 'id': ele.id }))
                for (let i in info) {
                    state.pointCoor[info[i].name] = [info[i].longitude, info[i].latitude]
                }
                state.events = res.events
            }, 0)
        })

        // 所有节点振动数据
        get_all_v().then(res => {
            setTimeout(() => { state.all_v = res }, 0)
        })

        // 页面权限信息
        get_pages_config().then(res => {
            setTimeout(() => {
                state.permission = {
                    ...state.permission,
                    ...res,
                    components: {
                        ...state.permission.components,
                        ...(res.components || {})
                    },
                    pages: {
                        ...state.permission.pages,
                        ...(res.pages || {}),
                        three: {
                            ...state.permission.pages.three,
                            ...((res.pages && res.pages.three) || {})
                        }
                    }
                }
                state.permission_loaded = true
            }, 0)
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                console.error('Authentication required. Redirecting to login page...');
                logout()
            } else {
                console.log(error);
            }
        })

        // 三维页面配置
        get_three_config().then(res => {
            setTimeout(() => { state.three = res }, 0)
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                console.error('Authentication required. Redirecting to login page...');
                logout()
            } else {
                console.log(error);
            }
        })

        // 检波器全局参数
        get_geo_params().then(res => {
            setTimeout(() => { state.geo_params = res }, 0)
        }).catch(error => {
            if (error.response && error.response.status === 401) {
                console.error('Authentication required. Redirecting to login page...');
                logout()
            } else {
                console.log(error);
            }
        })
    },
    update_m_v_unit(state, payload) {
        // 防递归：如果正在更新中则跳过
        if (state._m_v_unit_lock) return;
        state._m_v_unit_lock = true;
        try {
            const indexToUpdate = payload.index;
            if (indexToUpdate >= 0 && indexToUpdate < state.m_v_unit.length) {
                const updatedArray = state.m_v_unit.slice(); // 创建副本
                updatedArray.splice(indexToUpdate, 1, payload.v_unit); // 修改副本
                state.m_v_unit = updatedArray; // 更新 state.m_v_unit
                // 单位设置不需要持久化到缓存
            } else {
                console.error('索引越界或无效');
            }
        } finally {
            // 用 nextTick 延迟解锁，确保 Vue 响应式更新完成
            setTimeout(() => { state._m_v_unit_lock = false; }, 100);
        }
    },
    update_last_time(state, last_time) {
        state.last_time = last_time
    },
    update_user_configs(state, userConfigs) {
        state.permission.user_configs = userConfigs || {}
    },
    // 实时曲线参数重置
    reset_config(state) {
        state.fft_max = state.time_interval/2
        state.fft_min = 0
        state.fft = true
        state.amp_max = null
        state.amp_min = null
        state.time_last = 3
        state.v_unit = 0
    }
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js